<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-3">
        <b-field label="Protractor Template">
          <b-autocomplete
            :data="protractor_templates"
            field="title"
            open-on-focus
            @select="(option) => (protractor.template = option.id)"
          >
            <template slot-scope="props">
              <div class="media">
                <div class="media-left">
                  <img width="64" :src="props.option.img" />
                </div>
                <div class="media-content">
                  {{ props.option.title }}
                </div>
              </div>
            </template>
          </b-autocomplete>
        </b-field>
      </div>
      <div class="columns is-6 pt-3">
        <div class="column">
          <b-field label="Measurement Direction">
            <b-select
              placeholder="Angle Direction"
              v-model="protractor.angle_direction"
            >
              <option value="C">Clockwise</option>
              <option value="AC">Anti-Clockwise</option>
            </b-select>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Angle" grouped>
            <up-numberinput
              v-model="protractor.angle"
              label="Angle"
              :value="protractor.angle"
              labelIcon="mdi mdi-alpha-a-box-outline"
            ></up-numberinput>
            <b-field expanded>
              <!-- <b-select placeholder="Angle" v-model="protractor.angle" expanded>
								<option v-for="angle in listAngle" :key="`ANGLE_${angle}`" :value="angle">{{angle}}</option>
							</b-select> -->
              <b-switch
                class="mx-3"
                v-model="protractor.is_angle_hidden"
                size="is-small"
                :rounded="false"
                >Hide Angle</b-switch
              >
            </b-field>
          </b-field>
        </div>
        <div class="column" v-if="protractor.is_user_selectable">
          <b-field label="Answer Angle" grouped>
            <up-numberinput
              v-model="protractor.answer_angle"
              label="Answer Angle"
              :value="protractor.answer_angle"
              labelIcon="mdi mdi-alpha-a-box-outline"
            ></up-numberinput>
          </b-field>
        </div>
      </div>
    </div>
    <style-editor
      title="Protractor"
      show_width
      show_height
      show_bg_color
      v-model="protractor.styles"
    />
    <style-editor
      title="Arrow"
      show_bg_color
      show_width
      show_height
      v-model="protractor.arrow_styles"
    />
    <div class="py-2">
      <b-field expanded>
        <b-switch
          v-model="protractor.is_user_selectable"
          size="is-small"
          :rounded="false"
        >
          Is User Selectable
        </b-switch>
      </b-field>
    </div>
    <show-protractor :protractor="protractor" />
  </div>
</template>
<script>
import StyleEditor from "@/components/Common/StyleEditor/StyleEditor.vue";
import ShowProtractor from "@/components/Question/Protractor/ShowProtractor";
import UpNumberinput from "@/components/UI/Inputs/UpNumberinput";
import { protractor_templates, defaultProtractorValue } from "./utils";

export default {
  name: "set-protractor",
  components: {
    UpNumberinput,
    StyleEditor,
    ShowProtractor,
  },
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      protractor: this.value ? this.value : defaultProtractorValue(),
      protractor_templates,
    };
  },
  watch: {
    protractor: {
      handler: function (new_val) {
        this.$emit("input", new_val);
      },
      deep: true,
    },
    value: {
      handler: function (new_val) {
        this.protractor = new_val;
      },
      deep: true,
    },
  },
  computed: {},
};
</script>
